import { useEffect, useRef, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import AudioBubble from "@/components/AudioBubble";
import MessageComposer from "@/components/MessageComposer";
import { MessageCircle } from "lucide-react";

const CATEGORIES = {
  geral: "Mensagem geral", atividade: "Sobre uma atividade", material: "Sobre um material",
  proxima_sessao: "Conversar na próxima sessão", solicitacao_contato: "Solicitação de contato",
  reagendamento: "Reagendamento", apoio: "Preciso de apoio",
};

export default function PatientMessages() {
  const { user } = useAuth();
  const [msgs, setMsgs] = useState([]);
  const endRef = useRef(null);

  const load = async () => {
    const { data } = await api.get(`/messages?patient_id=${user.id}`);
    setMsgs(data);
  };
  useEffect(() => { load(); }, []);
  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [msgs]);

  return (
    <div className="max-w-2xl mx-auto flex flex-col h-[calc(100vh-8rem)] animate-fade-up">
      <div className="mb-3">
        <h1 className="font-heading text-2xl font-bold text-[#1F3B4D] flex items-center gap-2">
          <MessageCircle className="text-[#0F766E]" /> Mensagens
        </h1>
        <p className="text-sm text-[#94A3B8]">Fale com seu profissional por texto ou áudio.</p>
      </div>

      <Card className="flex-1 rounded-2xl border-[#E0F2FE] p-4 overflow-auto space-y-3" data-testid="messages-thread">
        {msgs.map((m) => {
          const mine = m.sender_id === user.id;
          return (
            <div key={m.id} className={`flex ${mine ? "justify-end" : "justify-start"}`}>
              <div className={`max-w-[80%] rounded-2xl px-4 py-2.5 ${mine ? "bg-[#0F766E] text-white" : "bg-[#E0F2FE] text-[#1F3B4D]"}`}>
                {m.category && m.category !== "geral" && (
                  <Badge className={`mb-1 border-0 text-[10px] ${mine ? "bg-white/20 text-white" : "bg-white text-[#0F766E]"}`}>
                    {CATEGORIES[m.category] || m.category}
                  </Badge>
                )}
                {m.type === "audio"
                  ? <AudioBubble fileId={m.audio_file_id} duration={m.duration} transcript={m.transcript} mine={mine} />
                  : <p className="text-sm whitespace-pre-wrap">{m.text}</p>}
                <div className={`text-[10px] mt-1 ${mine ? "text-white/60" : "text-[#94A3B8]"}`}>{new Date(m.created_at).toLocaleString("pt-BR", { hour: "2-digit", minute: "2-digit", day: "2-digit", month: "2-digit" })}</div>
              </div>
            </div>
          );
        })}
        {msgs.length === 0 && <p className="text-center text-sm text-[#94A3B8] mt-8">Nenhuma mensagem ainda.</p>}
        <div ref={endRef} />
      </Card>

      <div className="mt-3">
        <MessageComposer patientId={user.id} showCategory onSent={load} />
      </div>
    </div>
  );
}
